var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container.is-widescreen",staticStyle:{"padding":"18px"}},[_c('div',[_c('h1',{staticClass:"title",staticStyle:{"color":"#3e8ed0"}},[_vm._v("Welcome")]),_c('h4',{staticClass:"subtitle"},[_vm._v("Welcome to the SMS gateway system for Virtual SC.")])])])])
}]

export { render, staticRenderFns }